<template>
  <div class="video_con">
    <video ref="video" muted controls class="video" />
  </div>
</template>

<script>
const Hls = require('../../node_modules/hls.js/dist/hls')
export default {
  props: {
    videoObj: {
      type: Object,
      default: function () {
      }
    }
  },
  data () {
    return {
      hls: null
    }
  },
  mounted () {
    this.getStream(this.videoObj.cameraPath)
  },
  beforeDestroy () {
    this.videoPause()
  },
  methods: {
    getStream (source) {
      if (Hls.isSupported()) {
        this.hls = new Hls()
        this.hls.loadSource(source)
        this.hls.attachMedia(this.$refs.video)
        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
          this.$refs.video.play()
        })
      }
    },
    // 停止流
    videoPause () {
      if (this.hls) {
        this.$refs.video.pause()
        this.hls.destroy()
        this.hls = null
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .video_con{
    width: 100%;
    height: 100%;

    video{
      height: 100%;
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/video.vue